"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.installerUrl = exports.protocol = exports.hiddenStyleList = void 0;
/** @ignore */
exports.hiddenStyleList = "\n  display: none !important;\n  width: 1px !important;\n  height: 1px !important;\n  position: fixed !important;\n  z-index: -99 !important;\n  bottom: 0px !important;\n  right: 0px !important;\n";
/** @ignore */
exports.protocol = 'aspera://';
/** @ignore */
exports.installerUrl = 'https://downloads.ibmaspera.com/downloads/desktop/latest/stable';
